
import { supabase } from '@/integrations/supabase/client';
import { RoadmapTemplate } from '@/types/roadmap';
import { handleError } from '../utils';

export async function updateTemplateRecord(template: RoadmapTemplate): Promise<void> {
  console.log('updateTemplateRecord: Starting update for template:', template.id);
  console.log('updateTemplateRecord: Access control settings:', { 
    accessType: template.accessType, 
    isPublic: template.isPublic 
  });
  
  // Ensure access control fields are properly set
  const accessType = template.accessType || 'public';
  const isPublic = template.isPublic !== false;
  
  console.log('updateTemplateRecord: Normalized access control:', { accessType, isPublic });
  
  // Build update object with correct keys and values
  const updateObject = {
    title: template.title,
    description: template.description,
    page_title: template.pageTitle,
    embed_url: template.embedUrl,
    embed_title: template.embedTitle,
    access_type: accessType,
    is_public: isPublic,
    tags: template.tags || [],
    embedcode: template.embedCode || '',
    lessonhtml: template.lessonHtml || '',
    updated_at: new Date().toISOString()
  };
  console.log('updateTemplateRecord: UPDATE OBJECT:', updateObject);
  console.log('updateTemplateRecord: embedcode value:', updateObject.embedcode);
  console.log('updateTemplateRecord: lessonhtml value:', updateObject.lessonhtml);

  // Update the main template record with access control fields
  const { error: templateError, data, count } = await supabase
    .from('roadmap_templates')
    .update(updateObject)
    .eq('id', template.id)
    .select();

  console.log('updateTemplateRecord: SUPABASE UPDATE RESULT:', { error: templateError, data, count });

  if (templateError) {
    console.error('updateTemplateRecord: Error updating template:', templateError);
    throw templateError;
  }

  console.log('updateTemplateRecord: Successfully updated template with access type:', accessType, 'and isPublic:', isPublic);
}
